import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_select_list extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_select_list">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Select List</h2>
              <p>
                Select lists or dropdown list provide the user the ability to
                select an option form a pre-populated list. Select lists support
                multiple selects, allowing the user to select more than one
                option at a time. When in single select mode, select lists
                support icons and colors.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_select_list"}
                name={"select list"}
                dataNameDefault={
                  '"text_my_db_text_field" or "long_my_db_number_field" or array_text_my_list or "object_my_obj.text_my_text_field"'
                }
                autoFill={'"my value" or 123 or ["Option 1", "Option 2"]'}
                padding={true}
                hide={true}
                order={true}
                button={false}
                tabIndex={true}
                readOnly={true}
                displayName={true}
                onChangeEval={true}
                sourceUrl={true}
                sourceSave={true}
                onClick={true}
                properties={[
                  {
                    property: "source_option_name",
                    description:
                      "The value that will be displayed when an option is selected.",
                    defaults: '"text_my_field" default "id"',
                  },
                  {
                    property: "source_option_value",
                    description:
                      "The value that will be saved when an option is selected.",
                    defaults: '"text_my_field" default "id"',
                  },
                  {
                    property: "multiple",
                    description:
                      "Allow user to select mutlple options. Note requires an array data type.",
                    defaults: "true, false default is false",
                  },
                  {
                    property: "options",
                    description:
                      "This is where you set out your list of options the user can select. Options can include icons, and colors. For more detials see the table below which outlines the options properties.",
                    defaults: "{ ... }",
                  },
                ]}
              />

              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">color</td>
                    <td>
                      The color of the icon (if icon is defined). For help
                      choosing colors please refer to the colors section of this
                      documention.
                      <br />
                      <i>"4caf50"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">disabled</td>
                    <td>
                      Stops the user from being able to select this option.
                      <br />
                      <i>true or false default if false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">icon</td>
                    <td>
                      This is an options option to include an icon from the
                      material icon font. For more detials look at the icon
                      section of this document.
                      <br />
                      <i>"home"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">hide</td>
                    <td>
                      Hide this option from the interface.
                      <br />
                      <i>true or false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">name</td>
                    <td>
                      The displayed text name of the option.
                      <br />
                      <i>
                        <strong>"Select me"</strong>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>
                      The display order of options in the list.
                      <br />
                      <i>7</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value</td>
                    <td>
                      The data value of the selected option.
                      <br />
                      <i>
                        <strong>"on" or 3</strong>
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Select List Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Select List</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_select_list"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"text_my_field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My Field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"options"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"opt1"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Start"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"value"</span>:{" "}
                  <span className="jsonY">"Start"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"icon"</span>:{" "}
                  <span className="jsonY">"play_arrow"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"color"</span>:{" "}
                  <span className="jsonY">"#4caf50"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">"opt2"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Stop"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"value"</span>:{" "}
                  <span className="jsonY">"Stop"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"icon"</span>:{" "}
                  <span className="jsonY">"stop"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"color"</span>:{" "}
                  <span className="jsonY">"#E53935"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>

            <section>
              <h3>Example 2: Multiple Select List</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_select_list"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"array_text_my_field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My Field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"multiple"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"options"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"opt1"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Start"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"value"</span>:{" "}
                  <span className="jsonY">"Start"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">"opt2"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Stop"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"value"</span>:{" "}
                  <span className="jsonY">"Stop"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_select_list;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_select_list.js